import { render } from "./DocumentItem.vue?vue&type=template&id=f0e53320"
import script from "./DocumentItem.vue?vue&type=script&lang=js"
export * from "./DocumentItem.vue?vue&type=script&lang=js"

import "./DocumentItem.vue?vue&type=style&index=0&id=f0e53320&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__